import queryString from 'query-string';
import { path } from 'ramda';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import type { RootState } from 'store/configureStore';
import { getIsLoggedIn, getFeatureFlagValue } from 'store/session/selectors';

const getScope = (state: RootState) => state.app;

export const isLoaded = (state: RootState) => state.app.loaded;

export const getModel = (state: RootState) => getScope(state).model;

export const getData = (state: RootState) => getModel(state);

export const getRouter = (state: RootState) => state.router;

export const getRouterSearchParams = (state: RootState) => {
  const search = path<string>(['location', 'search'], getRouter(state));
  return search ? queryString.parse(search) : {};
};

export const getIsLoaded = (state: RootState) => getScope(state).isLoaded;

export const getIsFetching = (state: RootState) => getScope(state).isFetching;

export const getDidUserSessionExpire = (state: RootState) =>
  getScope(state).userSessionExpired;

export const getNextLocation = (state: RootState) =>
  getScope(state).nextLocation;

export const getPrevLocation = (state: RootState) =>
  getScope(state).prevLocation;

export const getLocation = (state: RootState) => getScope(state).location;

export const getError = (state: RootState) => getScope(state).error;

export const getHomePage = (state: RootState, isLoggedIn = null) => {
  if (isLoggedIn === null || isLoggedIn === true) {
    if (
      getFeatureFlagValue(state, featureFlagKeys.isQuotingToolAvailable) ===
      false
    ) {
      return '/parts?page=1&tab=our_parts';
    }
    return '/home';
  } else {
    // route non-logged in users to login page
    return '/login';
  }
};

export const getHomeOrLoginPage = (state: RootState) =>
  getIsLoggedIn(state) ? getHomePage(state) : '/login';
